import {useEffect} from 'react'
import {useAuth} from './core/Auth'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    logout()
    // Auth/registration live in the standalone app at /auth/* — leave this bundle entirely.
    window.location.assign('/auth/login')
  }, [logout])

  return null
}
